import axios from 'axios';

import { LogService } from '../log-service';

export const getSellerIORs = async () => {
  try {
    const response = await axios.get('/iors');
    const result = response?.data ?? { importerOfRecords: [] };
    return result.importerOfRecords.reduce((acc, d) => {
      return { ...acc, [d.id]: d };
    }, {});
  } catch (error) {
    LogService.logError(new Error('Error fetching seller IORs', { cause: error }));
  }
};

export const addSellerIOR = async (data) => {
  const response = await axios.post('/iors', data);
  const result = response?.data ?? [];
  return result;
};

export const deleteSellerIOR = async (iorId) => {
  const response = await axios.delete(`/iors/${iorId}`);
  const result = response?.data ?? [];
  return result;
};
